var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

/**
 * The `TrackFill` component is used for showing a colored bar
 * within the `Track` component to show the `Slider`'s position.
 *
 * If the `Slider` is disabled, this will just return null.
 */

var TrackFill = function (_PureComponent) {
  _inherits(TrackFill, _PureComponent);
  function TrackFill() {
    _classCallCheck(this, TrackFill);
    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
  }
  TrackFill.prototype.render = function render() {
    var _props = this.props,
      style = _props.style,
      className = _props.className,
      trackFillWidth = _props.trackFillWidth,
      dragging = _props.dragging,
      disabled = _props.disabled,
      props = _objectWithoutProperties(_props, ['style', 'className', 'trackFillWidth', 'dragging', 'disabled']);
    if (disabled) {
      return null;
    }
    return React.createElement('hr', _extends({}, props, {
      style: Object.assign({}, style, {
        width: trackFillWidth
      }),
      className: cn('md-slider-track-fill', className, {
        'md-slider-track-fill--dragging': dragging
      })
    }));
  };
  return TrackFill;
}(PureComponent);
TrackFill.propTypes = {
  style: PropTypes.object,
  className: PropTypes.string,
  dragging: PropTypes.bool,
  disabled: PropTypes.bool,
  trackFillWidth: PropTypes.string.isRequired
};
export default TrackFill;